import { useState } from 'react';

interface TeamMember {
  name: string;
  nameEn: string;
  role: string;
  bio: string;
  detail: string;
  img: string;
  tags: string[];
  stats: { value: string; label: string }[];
  quote: string;
}

const team: TeamMember[] = [
  {
    name: '莊詔傑',
    nameEn: 'Ethan Chuang',
    role: '創辦人 / 首席設計顧問',
    bio: '15年商業空間設計經驗，曾主導超過100個商業空間案例，擅長整合品牌策略與空間設計，打造真正有商業說服力的空間。',
    detail: '畢業於國立台灣科技大學設計學院，早年任職於日本知名商業設計事務所累積國際視野，返台後創立心旅商研，立志讓台灣商業空間設計走向「策略先行、設計落地」的全新模式。',
    img: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/8e74ecf76c969466ae9b5f84dc96abe9.jpeg',
    tags: ['品牌空間策略', '商業設計', '工程整合'],
    stats: [
      { value: '15+', label: '年資歷' },
      { value: '100+', label: '案例主導' },
      { value: '3', label: '個獎項' },
    ],
    quote: '空間是品牌最立體、最真實的表達，設計的起點永遠是策略。',
  },
  {
    name: '蘇雅晴',
    nameEn: 'Yaching Su',
    role: '設計總監',
    bio: '擁有豐富的餐飲與零售空間設計資歷，以細膩的品牌感知能力與商業設計美學聞名業界，每個空間都是一首品牌詩篇。',
    detail: '曾任職米其林餐廳品牌設計顧問，主導超過40個餐飲品牌的空間轉型，擅長在有限預算內創造最大品牌視覺張力，對燈光設計與材料語彙有極深造詣。',
    img: 'https://readdy.ai/api/search-image?query=asian%20professional%20female%20interior%20designer%20portrait%20creative%20confident%20elegant%20natural%20studio%20light%20warm%20smile%20clean%20simple%20neutral%20background%20formal%20attire%20refined%20look&width=400&height=500&seq=team002x&orientation=portrait',
    tags: ['餐飲空間', '零售設計', '品牌美學'],
    stats: [
      { value: '40+', label: '餐飲案例' },
      { value: '8+', label: '年資歷' },
      { value: '2', label: '設計獎項' },
    ],
    quote: '每個好空間都有靈魂，那靈魂是品牌的相信與堅持。',
  },
  {
    name: '吳建民',
    nameEn: 'Justin Wu',
    role: '工程整合總監',
    bio: '深耕商業空間工程領域逾12年，統籌設計與施工整合，確保每個案件準時、準確、不超預算落地。',
    detail: '擁有建築工程師執照及室內裝修工程管理資格，曾統籌最大單一案件達500坪的複合式商業空間工程，以嚴謹的品質管控體系和透明的施工回報機制贏得業主高度信任。',
    img: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/7e39e50fafe4f35b45e233f08d4c8ea1.png',
    tags: ['工程管理', '材料應用', '預算控管'],
    stats: [
      { value: '12+', label: '年資歷' },
      { value: '500坪', label: '最大單案' },
      { value: '98%', label: '準時完工' },
    ],
    quote: '工程的細節決定設計的成敗，每一釘每一縫都關係著品牌的尊嚴。',
  },
  {
    name: '林佩瑩',
    nameEn: 'Peiying Lin',
    role: '品牌策略顧問',
    bio: '橫跨品牌管理與商業空間的跨界顧問，協助業主在動工之前先釐清品牌定位，確保空間設計方向與商業目標完全一致。',
    detail: '曾任台灣知名廣告集團品牌策略總監，服務過多個知名連鎖餐飲及零售品牌，近年跨入商業空間領域，開創「策略先於設計」的服務模式，成為心旅商研差異化的核心優勢之一。',
    img: 'https://readdy.ai/api/search-image?query=asian%20professional%20female%20brand%20strategist%20consultant%20portrait%20confident%20poised%20warm%20natural%20light%20elegant%20office%20attire%20clean%20neutral%20background%20thoughtful%20expression%20business%20woman&width=400&height=500&seq=team004x&orientation=portrait',
    tags: ['品牌定位', '消費者洞察', '商業策略'],
    stats: [
      { value: '60+', label: '品牌服務' },
      { value: '10+', label: '年資歷' },
      { value: '5', label: '連鎖品牌' },
    ],
    quote: '一個好的品牌空間，首先是一個好的品牌決策——空間設計是那個決策最美的具現。',
  },
];

export default function TeamSection() {
  const [expanded, setExpanded] = useState<number | null>(null);

  return (
    <section className="py-24 md:py-32 bg-[#fafaf8]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">Our Team</p>
            <h2
              className="font-bold text-[#1a1a1a] leading-[1.35]"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              核心團隊
            </h2>
          </div>
          <p className="text-[#5a5a5a] max-w-md" style={{ fontSize: '1.1875rem' }}>
            設計、策略、工程三位一體，共同為你的商業空間創造最大價值。
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 xl:gap-8">
          {team.map((member, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl overflow-hidden border border-[#ede9e4] hover:border-[#b8956a]/40 transition-all duration-300"
            >
              <div className="flex flex-col sm:flex-row">

                {/* Photo */}
                <div className="sm:w-[200px] flex-shrink-0">
                  <div className="w-full h-[240px] sm:h-full min-h-[240px] overflow-hidden">
                    <img
                      src={member.img}
                      alt={member.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-600"
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 p-6 flex flex-col">

                  {/* Name + role */}
                  <div className="mb-4">
                    <div className="flex items-baseline gap-2 flex-wrap">
                      <h3
                        className="font-bold text-[#1a1a1a] leading-[1.3]"
                        style={{ fontSize: '1.1875rem' }}
                      >
                        {member.name}
                      </h3>
                      <span
                        className="text-[#b8b0a6] font-light"
                        style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1rem' }}
                      >
                        {member.nameEn}
                      </span>
                    </div>
                    <p className="text-[#b8956a] text-sm font-medium mt-1">{member.role}</p>
                  </div>

                  {/* Bio */}
                  <p className="text-[#5a5a5a] text-sm leading-relaxed mb-4 flex-1">
                    {member.bio}
                  </p>

                  {/* Stats */}
                  <div className="flex gap-5 mb-4">
                    {member.stats.map((s) => (
                      <div key={s.label}>
                        <p className="font-bold text-[#1a1a1a]" style={{ fontSize: '1.125rem' }}>{s.value}</p>
                        <p className="text-[#8a8a8a] text-xs mt-0.5">{s.label}</p>
                      </div>
                    ))}
                  </div>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {member.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2.5 py-1 bg-[#f4f2ef] text-[#5a5a5a] text-xs rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  {/* Expand toggle */}
                  <button
                    onClick={() => setExpanded(expanded === i ? null : i)}
                    className="flex items-center gap-1.5 text-[#b8956a] text-xs font-medium cursor-pointer hover:gap-2.5 transition-all duration-200 w-fit"
                  >
                    {expanded === i ? '收起詳細介紹' : '查看完整介紹'}
                    {expanded === i
                      ? <i className="ri-arrow-up-s-line text-sm"></i>
                      : <i className="ri-arrow-down-s-line text-sm"></i>
                    }
                  </button>
                </div>
              </div>

              {/* Expanded detail */}
              <div
                className={`overflow-hidden transition-all duration-400 ${expanded === i ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="mx-6 mb-6 p-5 bg-[#fafaf8] rounded-xl border border-[#ede9e4]">
                  {/* Quote */}
                  <div className="flex gap-3 mb-4">
                    <i className="ri-double-quotes-l text-[#b8956a] text-xl flex-shrink-0 mt-0.5"></i>
                    <p
                      className="text-[#3a3a3a] leading-[1.75] italic"
                      style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.0625rem' }}
                    >
                      {member.quote}
                    </p>
                  </div>
                  {/* Detail */}
                  <p className="text-[#5a5a5a] text-sm leading-[1.8]">
                    {member.detail}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom join CTA */}
        <div className="mt-16 bg-[#1a1a1a] rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-3">Join Our Team</p>
            <h3 className="font-bold text-white mb-2" style={{ fontSize: '1.375rem' }}>
              想加入心旅商研的行列？
            </h3>
            <p className="text-white/55 text-sm leading-relaxed max-w-lg">
              我們持續尋找對商業空間設計充滿熱情、同時具備商業思維的夥伴。
              如果你相信空間可以改變品牌命運，歡迎與我們聯繫。
            </p>
          </div>
          <a
            href="mailto:newplusdesign2017@gmail.com"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#b8956a] text-white font-semibold rounded-full whitespace-nowrap hover:bg-[#a07d58] transition-colors cursor-pointer text-[1rem] flex-shrink-0"
          >
            <i className="ri-mail-send-line"></i>
            寄送求職信件
          </a>
        </div>

      </div>
    </section>
  );
}
